import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Container, VersionInfo } from "./styles";

export default function News() {
  return (
    <Container>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-15-1-content" id="version-6-15-1-header">
          <VersionInfo>Versão 6.15.1 <span>27/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Rematrícula distingue a série esperada, outros destinos e mudanças de turno, com lista dos alunos que compõem cada contagem.</li>
          <li>Conferência automática dos totais de turmas, séries, segmentos, tipos de matrícula e histórico, com aviso para cadastros divergentes.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-15-0-content" id="version-6-15-0-header">
          <VersionInfo>Versão 6.15.0 <span>26/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Análise da campanha por intervalo de datas de matrícula, comparando períodos equivalentes nas últimas cinco campanhas.</li>
          <li>Novatos, veteranos, evolução acumulada, diferenças entre campanhas e detalhamento por segmento e turma no período escolhido.</li>
          <li>Excel com os intervalos comparados, resultados filtrados e indicação de matrículas sem data válida.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-14-0-content" id="version-6-14-0-header">
          <VersionInfo>Versão 6.14.0 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Nova análise gerencial dos últimos cinco anos, com evolução de novatos e veteranos, comparativos por segmento e turma e exportação para Excel.</li>
          <li>Turmas agrupadas por série em acordeões, com totais visíveis e detalhes ao abrir cada grupo.</li>
          <li>Histórico conferido com o cadastro oficial de turmas por ano, distinguindo dados indisponíveis de zero matrículas.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-13-5-content" id="version-6-13-5-header">
          <VersionInfo>Versão 6.13.5 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Análise estatística com gráficos e legendas completos, layout adaptável e tabelas mais legíveis.</li>
          <li>Corrigidas as contagens de contratos rescindidos e a comparação por turma e turno com o ano anterior.</li>
          <li>Acompanhamento da rematrícula pelo aluno, com aviso quando uma consulta não puder ser confirmada.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-13-4-content" id="version-6-13-4-header">
          <VersionInfo>Versão 6.13.4 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Recuperadas opções históricas de matrícula registradas nas observações, preservando dados já preenchidos.</li>
          <li>Contrato sem informação explícita permanece como Não informado, sem presumir que não foi assinado.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-13-3-content" id="version-6-13-3-header">
          <VersionInfo>Versão 6.13.3 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Corrigida a estrutura de armazenamento de contrato, pagamento e uso de imagem nas duas unidades, com gravação e leitura verificadas.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-13-2-content" id="version-6-13-2-header">
          <VersionInfo>Versão 6.13.2 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento permite salvar os dados preenchidos mesmo quando não consegue recuperar informações anteriores de contrato, pagamento e imagem.</li>
          <li>Uma falha no registro adicional é informada separadamente, sem interromper a atualização dos responsáveis ou a geração do PDF.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-13-1-content" id="version-6-13-1-header">
          <VersionInfo>Versão 6.13.1 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto e carnê consulta os registros salvos sem recarregar as fichas completas; observações antigas podem ser consultadas separadamente.</li>
          <li>Gravação informa falhas e preserva os campos que não foram alterados. O requerimento recupera os dados locais mais recentes antes de editar.</li>
          <li>Consultas com erro mantêm os resultados anteriores e exibem aviso. Filtros sem resultados passam a explicar o motivo da lista vazia.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-13-0-content" id="version-6-13-0-header">
          <VersionInfo>Versão 6.13.0 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento ganhou visual compacto: seções completas são recolhidas e, ao terminar o preenchimento, a tela avança para o próximo campo pendente. Qualquer seção pode ser reaberta para conferir os dados.</li>
          <li>Saúde organizada em cartões com respostas rápidas, filtros de revisão e recuperação dos detalhes já salvos.</li>
          <li>Limpeza do formulário pede confirmação; contratos e assinaturas locais são removidos ao limpar ou trocar o aluno.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-12-0-content" id="version-6-12-0-header">
          <VersionInfo>Versão 6.12.0 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Autorização de retirada do aluno permite selecionar pai e mãe reaproveitando nome e contato da filiação, além de cadastrar até duas outras pessoas.</li>
          <li>As pessoas selecionadas são recuperadas no requerimento e aparecem com nome, vínculo e telefone no PDF.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-11-3-content" id="version-6-11-3-header">
          <VersionInfo>Versão 6.11.3 <span>20/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento simplificado: retirados tratamento médico geral, contatos de emergência e escolha do vencimento do boleto/carnê, mantendo informações já registradas.</li>
          <li>PDF do requerimento atualizado com o novo papel timbrado da campanha e margens ajustadas para preservar o rodapé.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-11-2-content" id="version-6-11-2-header">
          <VersionInfo>Versão 6.11.2 <span>15/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Listas de confirmados em PDF ganharam numeração contínua, totais por turma e geral, separadores e número de página para facilitar a conferência.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-11-1-content" id="version-6-11-1-header">
          <VersionInfo>Versão 6.11.1 <span>15/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>PDF de confirmados por turma aproveita a mesma folha para várias turmas e só muda de página quando faltar espaço.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-11-0-content" id="version-6-11-0-header">
          <VersionInfo>Versão 6.11.0 <span>15/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório estatístico de Eventos permite baixar PDFs para impressão dos alunos confirmados: lista geral ou separada por turma, somente com os nomes.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-6-content" id="version-6-10-6-header">
          <VersionInfo>Versão 6.10.6 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê volta a permitir edição e exportação quando a matrícula ainda não tem opção local salva.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-5-content" id="version-6-10-5-header">
          <VersionInfo>Versão 6.10.5 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Atualização do requerimento continua funcionando quando o status local de contrato e imagem ainda não está disponível no banco.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-4-content" id="version-6-10-4-header">
          <VersionInfo>Versão 6.10.4 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Atualização do requerimento não é mais bloqueada por falha isolada ao salvar status local de contrato e imagem.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-3-content" id="version-6-10-3-header">
          <VersionInfo>Versão 6.10.3 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Modal de assinatura digital ganhou área de assinatura 30% maior.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-2-content" id="version-6-10-2-header">
          <VersionInfo>Versão 6.10.2 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento passa a salvar contrato assinado, uso de imagem e restrições na tabela local ao atualizar dados ou gerar PDF.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-1-content" id="version-6-10-1-header">
          <VersionInfo>Versão 6.10.1 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório por turma aproveita melhor a folha A4 e a assinatura digital prioriza fidelidade imediata do traço.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-10-0-content" id="version-6-10-0-header">
          <VersionInfo>Versão 6.10.0 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de Matrículas inicia em 2027 e Pré-Matrícula e ganhou impressão por turma com totais e alunos agrupados.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-7-content" id="version-6-9-7-header">
          <VersionInfo>Versão 6.9.7 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Coleta de assinatura digital no requerimento ficou mais fluida, nítida e responsiva para mesa digitalizadora.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-6-content" id="version-6-9-6-header">
          <VersionInfo>Versão 6.9.6 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento aproxima a assinatura digital da linha no PDF e exibe avisos no rodapé da tela.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-5-content" id="version-6-9-5-header">
          <VersionInfo>Versão 6.9.5 <span>08/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê abre mais rápido com paginação e reconhece status salvos em formatos retornados pelo banco.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-4-content" id="version-6-9-4-header">
          <VersionInfo>Versão 6.9.4 <span>07/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê carrega contrato, uso de imagem e restrições por consulta local rápida, sem esperar dados completos dos alunos.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-3-content" id="version-6-9-3-header">
          <VersionInfo>Versão 6.9.3 <span>07/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê recupera dados auxiliares já presentes nas matrículas e melhora a resposta da janela com listas maiores.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-2-content" id="version-6-9-2-header">
          <VersionInfo>Versão 6.9.2 <span>07/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de Matrículas volta a listar dados mesmo quando os status locais de contrato ainda não estão disponíveis.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-1-content" id="version-6-9-1-header">
          <VersionInfo>Versão 6.9.1 <span>07/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>PDF do requerimento agora posiciona autorização de imagem e assinaturas do contrato pelos marcadores do próprio documento importado.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-9-0-content" id="version-6-9-0-header">
          <VersionInfo>Versão 6.9.0 <span>07/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê passa a mostrar autorização de uso de imagem e restrições informadas no requerimento.</li>
          <li>Geração do PDF e atualização cadastral agora exigem informar se o uso de imagem foi autorizado ou não.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-8-0-content" id="version-6-8-0-header">
          <VersionInfo>Versão 6.8.0 <span>07/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento de matrícula agora coleta autorização de uso de imagem e voz, registra restrições e preenche os novos marcadores do contrato 2027.</li>
          <li>Assinatura digital do requerimento e do contrato foi ajustada para preservar proporção e encaixar melhor nas linhas de assinatura.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-7-0-content" id="version-6-7-0-header">
          <VersionInfo>Versão 6.7.0 <span>02/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento de matrícula agora permite coletar assinatura digital, importar contrato em PDF e gerar um arquivo único com requerimento e contrato.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-6-0-content" id="version-6-6-0-header">
          <VersionInfo>Versão 6.6.0 <span>01/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento de matrícula agora permite marcar se o contrato foi assinado.</li>
          <li>Relatório de boleto/carnê passa a exibir a situação do contrato e usa registro próprio por aluno e ano letivo.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-5-1-content" id="version-6-5-1-header">
          <VersionInfo>Versão 6.5.1 <span>01/10/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê passa a preencher corretamente a forma de pagamento já salva no requerimento.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-5-0-content" id="version-6-5-0-header">
          <VersionInfo>Versão 6.5.0 <span>22/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Agenda Diária Modo Gráfico agora permite reutilizar a última agenda gerada e limpar os campos das aulas com um clique.</li>
          <li>Imagem gerada pela agenda atualizada para o layout 2027.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-4-2-content" id="version-6-4-2-header">
          <VersionInfo>Versão 6.4.2 <span>17/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de boleto/carnê movido para janela própria dentro do Relatório de Matrículas, com edição da forma de pagamento por aluno.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-4-1-content" id="version-6-4-1-header">
          <VersionInfo>Versão 6.4.1 <span>17/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Relatório de Matrículas agora permite consultar o ano letivo de 2027 para Campina Grande e Patos.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-4-0-content" id="version-6-4-0-header">
          <VersionInfo>Versão 6.4.0 <span>16/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Administradores podem cancelar inscrições informando o motivo, com encaminhamento para reembolso quando já existe pagamento.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-3-1-content" id="version-6-3-1-header">
          <VersionInfo>Versão 6.3.1 <span>16/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>No acompanhamento por turma, a escolha de participação aparece somente para alunos não inscritos ou com pagamento pendente.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-3-0-content" id="version-6-3-0-header">
          <VersionInfo>Versão 6.3.0 <span>16/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Acompanhamento por turma com respostas salvas e confirmação automática quando o pagamento pelo aplicativo confirma a inscrição.</li>
          <li>Ícone para reenviar cobrança por notificação aos responsáveis de inscritos com pagamento pendente.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="version-6-2-0-content" id="version-6-2-0-header">
          <VersionInfo>Versão 6.2.0 <span>15/09/2026</span></VersionInfo>
        </AccordionSummary>
        <AccordionDetails><ul>
          <li>Requerimento de matrícula com escolha de boleto ou carnê, salva nos dados do aluno e exibida no PDF.</li>
          <li>Relatório com nome dos alunos e forma de pagamento, filtro por opção e exportação para Excel.</li>
        </ul></AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-9-content"
          id="version-6-1-9-header"
        >
          <VersionInfo>
            Versão 6.1.9 <span>10/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>ℹ️ <strong>Informação financeira</strong>: parcelas pendentes continuam visíveis no requerimento sem impedir sua atualização ou geração do PDF</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-8-content"
          id="version-6-1-8-header"
        >
          <VersionInfo>
            Versão 6.1.8 <span>09/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>🔒 <strong>Regularidade financeira</strong>: o requerimento informa e bloqueia alunos com parcelas pendentes vencidas até a data do preenchimento</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-7-content"
          id="version-6-1-7-header"
        >
          <VersionInfo>
            Versão 6.1.7 <span>09/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📝 <strong>Naturalidade completa</strong>: busca oficial de municípios preenche cidade e UF juntas e impede o envio incompleto de alunos brasileiros</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-6-content"
          id="version-6-1-6-header"
        >
          <VersionInfo>
            Versão 6.1.6 <span>09/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>🔎 <strong>Busca de alunos</strong>: pesquisa por partes do nome, sem acentos, com seleção segura de alunos com nomes iguais</li>
            <li>⚡ <strong>Preenchimento do requerimento</strong>: lista mais leve, menos consultas repetidas e opção de tentar novamente quando o carregamento falhar</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-5-content"
          id="version-6-1-5-header"
        >
          <VersionInfo>
            Versão 6.1.5 <span>09/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📝 <strong>Formulário de matrícula</strong>: campo de naturalidade com mais espaço para a cidade, UF compacta e legenda simplificada</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-4-content"
          id="version-6-1-4-header"
        >
          <VersionInfo>
            Versão 6.1.4 <span>09/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📝 <strong>Naturalidade do aluno</strong>: cidade natal e UF separadas no requerimento, com envio corrigido para a Sponte</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-3-content"
          id="version-6-1-3-header"
        >
          <VersionInfo>
            Versão 6.1.3 <span>09/09/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📝 <strong>Matrículas 2027</strong>: requerimento atualizado para 2027 na tela e no PDF para impressão</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-2-content"
          id="version-6-1-2-header"
        >
          <VersionInfo>
            Versão 6.1.2 <span>24/08/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>💳 <strong>Confirmação de pagamentos de Eventos</strong>: pagamentos parcelados no cartão agora confirmam a inscrição corretamente mesmo quando o checkout inclui taxas no total cobrado</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-1-content"
          id="version-6-1-1-header"
        >
          <VersionInfo>
            Versão 6.1.1 <span>19/08/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>🔐 <strong>Permissão individual para recargas NFC</strong>: usuários autorizados pelo administrador agora podem realizar recargas, mesmo quando seu nível não é administrador ou caixa</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="version-6-1-0-content"
          id="version-6-1-0-header"
        >
          <VersionInfo>
            Versão 6.1.0 <span>19/08/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>🛒 <strong>Busca rápida no caixa da Cantina</strong>: identificação de alunos e colaboradores pelo nome, com atalho F5, pesquisa automática e navegação por teclado</li>
            <li>💳 <strong>Identificação por cartão mais moderna</strong>: modal reorganizado com busca prioritária, leitura NFC compacta e retorno visual mais claro</li>
            <li>🎟️ <strong>Gestão de Eventos aprimorada</strong>: busca de inscritos, filtro de pagamentos, paginação e relatórios estatísticos por turma</li>
            <li>🔐 <strong>Permissões detalhadas de Eventos</strong>: controle individual das funções disponíveis para cada usuário do sistema</li>
            <li>📝 <strong>Correção na atualização do requerimento</strong>: compatibilidade restaurada com a versão atual da integração Sponte</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 6.0.0 <span>07/01/2026</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>🔧 <strong>Correção Crítica no Sistema de Matrículas</strong>: sistema agora diferencia corretamente alunos e responsáveis mesmo quando compartilham o mesmo idSponte, eliminando conflitos na matrícula e consulta</li>
            <li>🔍 <strong>Busca Inteligente por Tipo de Usuário</strong>: implementação de filtros por tipo (STUDENT/RESPONSABLE) em todas as buscas por idSponte para evitar confusão de dados</li>
            <li>📁 <strong>Melhorias na Integração com Google Drive</strong>: sistema agora cria permissões de leitura automaticamente para arquivos enviados, garantindo acesso público quando necessário</li>
            <li>🚀 <strong>Suporte para Envio a Pastas Específicas</strong>: nova funcionalidade para enviar arquivos a pastas específicas no Google Drive com configuração centralizada</li>
            <li>🔄 <strong>Endpoint de Atualização em Batch de Contratos</strong>: novo endpoint para atualizar múltiplos contratos simultaneamente na API Sponte, melhorando performance</li>
            <li>🔒 <strong>Configuração Robusta de CORS</strong>: implementação completa de CORS no backend e Nginx para tratamento adequado de requisições OPTIONS e segurança aprimorada</li>
            <li>🔐 <strong>Redirecionamento Automático HTTP para HTTPS</strong>: configuração de SSL e redirecionamento seguro em todos os domínios para maior segurança</li>
            <li>⚡ <strong>Melhorias no Tratamento de Erros da API Sponte</strong>: tratamento mais robusto de erros e formatação de dados na integração com Sponte</li>
            <li>📊 <strong>Refatoração da API de Diários</strong>: melhoria na estrutura de retorno e tratamento de dados para maior consistência</li>
            <li>🛠️ <strong>Otimizações de Performance</strong>: remoção de logs desnecessários e melhorias na legibilidade do código em toda a integração Sponte</li>
            <li>🧹 <strong>Limpeza e Organização de Código</strong>: refatoração de serviços e controllers para eliminar duplicação e melhorar manutenibilidade</li>
            <li>🔧 <strong>Melhorias no CI/CD</strong>: correções nos workflows de deploy e tratamento de erros no processo de build</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.11.0 <span>27/11/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📊 <strong>Exportação para Excel no Relatório de Matrículas</strong>: novo botão para baixar dados da tabela em formato Excel com valores numéricos prontos para cálculos</li>
            <li>💰 <strong>Formatação Financeira para Excel</strong>: valores e porcentagens exportados como números puros (sem formatação de moeda) para facilitar cálculos</li>
            <li>✅ <strong>Correção da Situação do Aluno nos Boletins</strong>: relatórios gerais agora exibem a situação atual (APROVADO/REPROVADO) em vez de sempre mostrar "CURSANDO"</li>
            <li>🎨 <strong>Correção do Layout da Coluna Pendências</strong>: harmonização visual e remoção de sobreposições no cabeçalho da tabela</li>
            <li>📝 <strong>Centralização das Legendas do Boletim</strong>: legendas (MA, MF, EF, Recuperação) agora são centralizadas e não cortam mais o texto</li>
            <li>🔧 <strong>Cálculo Dinâmico de Situação</strong>: sistema calcula automaticamente a situação do aluno baseado na média final e exame final atual</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.9.0 <span>22/12/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📊 <strong>Sistema de Análise Estatística Avançada</strong>: nova aba dedicada com gráficos e métricas detalhadas de matrículas</li>
            <li>📈 <strong>Gráficos Interativos por Segmento</strong>: visualização de distribuição por turno, série e nível educacional com dados reais</li>
            <li>🔍 <strong>Filtros Inteligentes de Matrículas</strong>: sistema completo de filtros por data, curso, tipo e turno com ordenação dinâmica</li>
            <li>📋 <strong>Tabela de Matrículas Enriquecida</strong>: exibição de dados completos incluindo CPF, data de nascimento e informações financeiras</li>
            <li>💰 <strong>Integração Financeira Completa</strong>: dados de responsável financeiro, valor da parcela e percentual de desconto</li>
            <li>⚠️ <strong>Sistema de Verificação de Pendências</strong>: detecção automática de documentos em falta com indicadores visuais</li>
            <li>🔧 <strong>Correção de Campos de Observação</strong>: ajuste na captura correta do campo "Observacao" para verificação de pendências</li>
            <li>📊 <strong>Classificação Educacional Inteligente</strong>: categorização automática em Infantil, Fundamental I, Fundamental II e Ensino Médio</li>
            <li>🔢 <strong>Contadores de Novatos e Veteranos</strong>: identificação automática baseada no tipo de matrícula (1=Novato, 2=Veterano)</li>
            <li>🎯 <strong>Filtro de Turmas de Integral</strong>: opção para incluir ou excluir turmas de período integral da análise</li>
            <li>📱 <strong>Interface Responsiva e Moderna</strong>: tabelas com ordenação clicável e colunas fixas para melhor navegação</li>
            <li>⚡ <strong>Performance Otimizada</strong>: carregamento eficiente de dados com cache inteligente e indicadores de progresso</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.8.0 <span>05/09/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📄 <strong>Otimização de PDFs do Requerimento</strong>: redução significativa do tamanho dos PDFs (de 50-90MB para ~5-10MB)</li>
            <li>🎯 <strong>Controle de Data de Atualização</strong>: sistema agora registra automaticamente "ATUALIZADO EM: [data]" nas observações</li>
            <li>🔔 <strong>Alerta Visual de Dados Atualizados</strong>: notificação vermelha destacada quando aluno possui dados recentemente atualizados</li>
            <li>📁 <strong>Integração com Google Drive</strong>: botão direto para acessar documentação do aluno no Google Drive</li>
            <li>🧹 <strong>Limpeza Automática do Formulário</strong>: formulário é completamente limpo ao trocar de aluno, eliminando dados antigos</li>
            <li>📝 <strong>Máscaras de Entrada Inteligentes</strong>: formatação automática de datas (DD/MM/AAAA) e telefones ((XX) XXXXX-XXXX)</li>
            <li>✅ <strong>Modal de Confirmação para Atualizações</strong>: confirmação antes de atualizar dados com campos não obrigatórios vazios</li>
            <li>🔧 <strong>Correções de Bugs</strong>: correção de alertas persistentes e problemas de formatação de data</li>
            <li>⚡ <strong>Performance Melhorada</strong>: otimizações na geração de PDFs e carregamento de dados</li>
            <li>🎨 <strong>Interface Aprimorada</strong>: melhorias visuais e experiência do usuário no sistema de requerimentos</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.7.0 <span>04/09/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📁 <strong>Sistema de Upload em Chunks para Arquivos Grandes</strong>: implementação de upload fragmentado para arquivos de até 500MB</li>
            <li>⚡ <strong>Upload Inteligente</strong>: arquivos pequenos (&lt;5MB) usam upload direto, arquivos grandes usam sistema de chunks automático</li>
            <li>🔄 <strong>Reconstrução Automática</strong>: sistema reconstrói arquivos automaticamente no servidor após receber todos os chunks</li>
            <li>📊 <strong>Barra de Progresso em Tempo Real</strong>: acompanhamento visual detalhado do progresso de upload com percentual</li>
            <li>🛡️ <strong>Validação de Tamanho</strong>: validação automática de arquivos com limite de 500MB e mensagens de erro claras</li>
            <li>🔧 <strong>Configuração Otimizada do Nginx</strong>: ajustes no servidor para suportar uploads grandes com timeouts adequados</li>
            <li>📱 <strong>Interface Aprimorada</strong>: exibição do tamanho dos arquivos, status de upload e tratamento de erros melhorado</li>
            <li>🚀 <strong>Performance Superior</strong>: uploads grandes agora são confiáveis mesmo em conexões instáveis</li>
            <li>🧹 <strong>Limpeza Automática</strong>: sistema remove arquivos temporários automaticamente após upload bem-sucedido</li>
            <li>📋 <strong>Logs Detalhados</strong>: sistema de debug avançado para monitoramento e resolução de problemas</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.6.0 <span>02/09/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>📝 <strong>Sistema de Requerimento de Matrícula 2026</strong>: novo formulário dinâmico para registro de matrículas</li>
            <li>🎯 <strong>Validação inteligente de campos</strong>: validação visual em tempo real com destaque vermelho para campos obrigatórios</li>
            <li>📄 <strong>Geração automática de PDF</strong>: documento de matrícula formatado profissionalmente em 2 páginas</li>
            <li>🔍 <strong>Busca otimizada de alunos</strong>: sistema de autocomplete para localização rápida de estudantes</li>
            <li>📊 <strong>Campos condicionais inteligentes</strong>: formulário adapta-se dinamicamente às respostas do usuário</li>
            <li>🏥 <strong>Seção de aspectos de saúde</strong>: coleta detalhada de informações médicas em layout otimizado</li>
            <li>👨‍👩‍👧‍👦 <strong>Gestão completa de responsáveis</strong>: cadastro flexível de pais, mães e responsáveis financeiros</li>
            <li>⚡ <strong>Interface responsiva e moderna</strong>: experiência de usuário aprimorada com Material-UI</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.5.0 <span>13/06/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>⚡ <strong>Atualização otimista das notas</strong>: agora, ao salvar uma nota, apenas o item alterado é atualizado na tela, sem recarregar toda a lista de alunos.</li>
            <li>🧹 <strong>Remoção do preventReload</strong>: simplificação do fluxo de atualização, eliminando timers e recarregamentos desnecessários.</li>
            <li>🚀 <strong>Experiência muito mais fluida</strong>: edição de notas ficou instantânea e sem "piscadas" na interface.</li>
            <li>🔒 <strong>Mais performance e robustez</strong> para turmas grandes e uso intensivo.</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.4.0 <span>10/06/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>🏆 <strong>Implementação do Sistema "Talento Autêntico"</strong> - Nova funcionalidade para análise de desempenho acadêmico</li>
            <li>📊 Sistema avançado de ranking com múltiplos critérios de classificação acadêmica</li>
            <li>🎯 Algoritmo inteligente de identificação automática das disciplinas mais difíceis da turma</li>
            <li>📈 Análise de consistência do desempenho dos alunos (desvio padrão das notas)</li>
            <li>🔄 Critérios justos de desempate: Média Geral → Menos Recuperações → Performance em Disciplinas Difíceis → Consistência</li>
            <li>📋 Interface transparente com rankings detalhados por turma e por disciplina específica</li>
            <li>🏫 Exibição do nome da turma no título para melhor contextualização</li>
            <li>💡 Tooltips explicativos para todos os critérios de avaliação</li>
            <li>📚 Painel expandível com ranking completo de dificuldade das disciplinas</li>
            <li>🎨 Interface moderna com cores, chips e troféus para facilitar a interpretação dos dados</li>
            <li>⚡ Substituição do botão "RECUPERAR BACKUPS" inútil por funcionalidade educacional relevante</li>
            <li>🔧 Sistema robusto com tratamento de erros, timeouts de segurança e logs detalhados</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.3.0 <span>14/05/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Correção crítica no arredondamento matemático das notas enviadas ao Sponte</li>
            <li>Padronização da formatação de notas em todo o sistema</li>
            <li>Melhoria na consistência do cálculo de AC1 e AC2 a partir das notas parciais</li>
            <li>Correção na exibição de valores decimais nas médias finais</li>
            <li>Otimizações de desempenho no processo de envio de notas</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.1.0 <span>15/04/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Melhorias na interface dos botões do Sistema de Avaliações</li>
            <li>Correção de espaçamento entre botões de ações em todo o sistema</li>
            <li>Melhorias visuais nos alertas e mensagens do sistema</li>
            <li>Implementação de recuperação de backups de notas por aluno</li>
            <li>Correções de bugs no cálculo de médias quando notas são removidas</li>
            <li>Aprimoramento da exportação de boletins por turma</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 5.0.0 <span>19/01/2025</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Início da preparação ano 2025</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.6.0 <span>06/10/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Adiciona seção de estatísticas de matrículas</li>
            <li>Adiciona controle de status do contrato</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.5.0 <span>07/09/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Adiciona a seção de envio de documentos</li>
            <li>Adiciona a seção de consulta de documentos</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.4.0 <span>02/08/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Altera o cardápio da unidade Patos</li>
            <li>Torna independente os cardápios de acordo com a unidade</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.3.1 <span>02/07/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Adicionado função de cadastro de professores</li>
            <li>Adicionado função de cadastro de usuários ( somente admin )</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.3.0 <span>19/06/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>
              Adicionado botão "VERIFICAR MÉDIAS" cuja função é ilustrar
              inconsistências entre o aplicativo e o Sponte.
            </li>
            <li>
              Melhoria no calculo das médias, arredondando os valores decimais.
            </li>
            <li>
              Verificação automática de falhas no calculo das médias bimestrais.
            </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.2.0 <span>09/06/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>
              Adição de cores para representar a situação do aluno em cada
              disciplina.
            </li>
            <li>
              Implementação de função para repetição automática de notas de
              avaliações.
            </li>
            <li>
              Inclusão de botão para cálculo automático da média bimestral.
            </li>
            <li>
              Adição de função para formatação de números inteiros com casas
              decimais.
            </li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.1.1 <span>02/05/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Exibição do controle de versões</li>
            <li>Correção na exibição dos links e anexos nos comunicados</li>
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <VersionInfo>
            Versão 4.1.0 <span>02/04/2024</span>
          </VersionInfo>
        </AccordionSummary>
        <AccordionDetails>
          <ul>
            <li>Excluir agendas</li>
            <li>Excluir comunicados</li>
            <li>Menu estatísticas melhorado</li>
            <li>Aumento da capacidade de envio de imagens mais pesadas</li>
          </ul>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}
